import { createSlice } from '@reduxjs/toolkit';

import { downloadSkuLabel, printSkuLabels} from '../../apis';
import { getIndiaQcSkuLabels } from './api';

export const PrintSticker = createSlice({

    name: 'PrintSticker',
    initialState: {
        loading: false,
        error: '' ,
        printStickerSuccess: false,
        downloadIndiaQcSkuLabelsSuccess: false
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
          if(action?.payload?.key) {
            return {
              ...state,
              [action.payload.key]: action.payload.value
            }
          }
          return { ...state }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(printSkuLabels.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(printSkuLabels.fulfilled, (state, action) => {
            state.loading = false;
            state.printStickerSuccess = true;
        })
        builder.addCase(printSkuLabels.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(getIndiaQcSkuLabels.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getIndiaQcSkuLabels.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadIndiaQcSkuLabelsSuccess = true;
        })
        builder.addCase(getIndiaQcSkuLabels.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
    }
})

export const {clearError, clear} = PrintSticker.actions
export default PrintSticker.reducer